import CalendarActionFolderIdResponse from 'owa-service/lib/contract/CalendarActionFolderIdResponse';
import itemId from 'owa-service/lib/factory/itemId';
import renameCalendarOperation from 'owa-service/lib/operation/renameCalendarOperation';
import { getChangeKeyByCalendarItemId, Calendar } from 'owa-calendar-cache';
import { getMailboxRequestOptions } from 'owa-request-options-types';

/**
 * Renames calendar on server
 * @param calendar instance of calendar
 * @param newCalendarName new calendar name
 */
export default function renameCalendarService(
    calendar: Calendar,
    newCalendarName: string
): Promise<CalendarActionFolderIdResponse> {
    const calendarId = calendar.id;

    return renameCalendarOperation(
        {
            itemId: itemId({
                Id: calendarId.id,
                ChangeKey: getChangeKeyByCalendarItemId(calendarId.id),
            }),
            newCalendarName: newCalendarName,
        },
        getMailboxRequestOptions(calendar.id.mailboxInfo)
    );
}
